skrilla.controller('seasonDetailsCtrl', function ($scope, searchService, $stateParams, modalService, cacheService, dataService, srefService) {
    $scope.sport = $stateParams.sport;
    cacheService.registerObject("contestSport", $scope.sport);
    $scope.validate = {}

    searchService.get("seasons/" + $stateParams.id).then(function(response){
        $scope.season = response.data;
        $scope.sport = response.data.tournament.sport
        $scope.season.startDate = new Date($scope.season.startDate);
        $scope.season.endDate = new Date($scope.season.endDate);
        searchService.get("matches/?season=" + $stateParams.id ).then(function(response1){
            if (response1.data.length > 0) {
                $scope.matches = response1.data[0].matches;

            }
        });
    })

    $scope.mergeTournament = function(){
        cacheService.registerObject("season", $scope.season);
        modalService.openModal("views/mergeTournamentModal/mergeTournamentModal.html", true, 'lg', true, true);
    }

    $scope.save = function(){
        if(dataService.validateSeason($scope.season, $scope.validate)) {
            modalService.confirm("Are you sure you'd like to update this season?", function () {
                searchService.put("seasons/" + $scope.sport + "/" + $scope.season.id, $scope.season, "Successfully updated").then(function (response) {

                });
            });
        }
    }

    $scope.createMatch = function(){
        srefService.go("createMatch", {sport: $scope.season.sport, seasonId: $scope.season.id, tournamentId: $scope.season.tournamentId})
    }
    $scope.createMarket = function () {
        srefService.go("createBettingMarket", {eventId: $scope.season.id, eventType: 'SEASON'});
    }

    $scope.getColor = function(match){
        return match.state === "COMPLETED" ? "light-green" : match.state === "CANCELLED" ? "light-red" : match.state === "LIVE" ? "light-blue" : null;
    }

});
